(function(){
  // Persist a deadline 24h after first visit (per device)
  const KEY = 'luvrib_advertorial_deadline';
  let deadline = parseInt(localStorage.getItem(KEY) || '0', 10);
  const now = Date.now();
  if (!deadline || deadline < now) {
    deadline = now + 24 * 60 * 60 * 1000;
    localStorage.setItem(KEY, deadline.toString());
  }

  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  function tick(){
    const diff = Math.max(0, deadline - Date.now());
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const txt = pad(h) + ':' + pad(m) + ':' + pad(s);
    const t1 = document.getElementById('countdown');
    const t2 = document.getElementById('big-countdown');
    if (t1) t1.textContent = txt;
    if (t2) t2.textContent = txt;
  }
  tick();
  setInterval(tick, 1000);
})();
